<template>
	<router-view/>
</template>

<script>
export default {
	name: "AdministrationContainer",
}
</script>

<style lang="scss" scoped>

</style>